<template>
  <div class="modal-backdrop" @click.self="$emit('close')">
    <div class="modal-content">
      <h2>Would you like to leave a tip? 💖</h2>
      <p>Your support helps us improve and deliver faster!</p>

      <div v-if="!tipGiven" class="modal-buttons">
        <button @click="chooseTip(true)">Yes, tip</button>
        <button @click="chooseTip(false)">No, continue</button>
      </div>

      <div v-if="tipGiven">
        <input type="number" v-model="tipAmount" placeholder="Enter your tip amount" />
        <button class="next-btn" @click="submitTip">Submit Tip</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tipGiven: false,
      tipAmount: 0
    };
  },
  methods: {
    chooseTip(choice) {
      if (choice) {
        this.tipGiven = true;
      } else {
        this.$emit('choose', 0);
        this.$emit('close');
      }
    },
    submitTip() {
      if (this.tipAmount && this.tipAmount > 0) {
        this.$emit('choose', this.tipAmount);
        this.$emit('close');
      }
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background-color: #222;
  border: 2px solid #444;
  border-radius: 10px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.modal-content h2 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: cornflowerblue;
}

.modal-content p {
  font-size: 1rem;
  color: #ccc;
  margin-bottom: 2rem;
}

.modal-buttons {
  display: flex;
  justify-content: space-around;
}

.modal-buttons button {
  background-color: cornflowerblue;
  color: #fff;
  padding: 0.6rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.modal-buttons button:hover {
  background-color: royalblue;
}

input {
  width: 100%;
  padding: 0.7rem;
  border-radius: 6px;
  border: 1px solid #555;
  background-color: #111;
  color: #fff;
  font-size: 1rem;
}

.next-btn {
  margin-top: 1rem;
  padding: 0.8rem 2rem;
  background-color: cornflowerblue;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.next-btn:hover {
  background-color: royalblue;
}
</style>
